/// <reference path="../../app.definition.ts" />

export let nudgeTours = (): any[] => {
    let tourList: any[] = [];
    // console.log("Loading tours:", eCareVault.Tours);

    // Load each tour from the Tours module (each tour is located in /src/client/app/common/nudges/tours/ as a separate file)
    for (let key of Object.getOwnPropertyNames(eCareVault.Tours)) {
        if (!eCareVault.Tours[key].disabled) {
            // console.log(" - Adding tour", key);
            tourList.push(eCareVault.Tours[key]);
        }
    }
    // console.log("Final Tour List:", tourList);
    tourList.sort((a, b) => (a.priority || 100) - b.priority || 100);
    return tourList;
};
